import { render, staticRenderFns } from "./MarketProductVisit.vue?vue&type=template&id=88b94766&scoped=true&"
import script from "./MarketProductVisit.vue?vue&type=script&lang=js&"
export * from "./MarketProductVisit.vue?vue&type=script&lang=js&"
import style0 from "./MarketProductVisit.vue?vue&type=style&index=0&id=88b94766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b94766",
  null
  
)

export default component.exports